import React from 'react';
import { useErrorBoundary } from '../context/ErrorBoundaryContext';
import ErrorMessage from './ErrorMessage';
import styles from './ErrorNotification.module.scss';

/**
 * Global error notification component that displays errors from the error boundary context
 * This component should be placed high in the component tree
 * 
 * @returns {JSX.Element|null} Rendered component or null if no errors
 */
const ErrorNotification = () => {
	const { errors, removeError } = useErrorBoundary();
	
	if (!errors.length) {
		return null;
	}

	return (
		<div 
			className={`${styles.ErrorNotificationContainer} top-0 end-0 my-2 px-2`}>
			{errors.map(error => (
				<ErrorMessage
					key={error.id}
					message={error.message}
					error={error.error}
					variant={error.variant}
					dismissible={error.dismissible}
					autoHideDuration={error.autoHideDuration}
					onDismiss={() => removeError(error.id)}
					showIcon={true}
				/>
			))}
		</div>
	);
};

export default ErrorNotification;